import React, { useContext } from "react";
import {
  Checkbox,
  Dropdown,
  Icon,
  PrimaryButton,
  Stack,
  TextField,
  Calendar,
  TooltipHost,
} from "@fluentui/react";
import studylistContext from "../../../../../context/studylist/StudylistContext";
import themeContext from "../../../../../context/theme/ThemeContext";
import { BASIC_STUDYLIST } from "../../../../../constants/Constants";
import BasicViewerSwitch from "../../../../../components/SVGComponents/BasicViewerSwitch";

const ApplyFilter = (props) => {
  const {
    setAllStudies,
    studyData,
    columns,
    allStudies,
    searchDto,
    setSearchDto,
    sortGlobal,
    setSortGlobal,
    filterInputValues,
    showFilters,
    setShowFilters,
    setApplyClick,
    filterBadges,
    setFilterBadges,
    removeBadgeFromFilter,
    storefilterBadges,
    setPatientDetail,
    trackApplyButton,
    setTrackApplyButton,
    patientNameBadgeShow,
    setPatientNameBadgeShow,
    handleEnterKeyPress,
    setFilterInputValues,
    storefilterInputValues,
    handleRefresh,
  } = useContext(studylistContext);

  const { themeName } = useContext(themeContext);

  return (
    <>
      <div className="section-apply">
        {/* <PrimaryButton
          text="Apply"
          onClick={() => {
            setTrackApplyButton(true);
            if (searchDto?.patientNameOrId?.length > 0) {
              setPatientNameBadgeShow(true);
            }

            setApplyClick(true);
            setTimeout(() => {
              handleRefresh();
            }, 500);
          }}
          className={!trackApplyButton?"common-default-active-button":"common-default-inactive-button"}
          // style={
          //   !trackApplyButton
          //     ? {
          //         fontSize: "12px",
          //         fontWeight: "400",
          //         padding: "0px 3px",
          //         height: "30px",
          //         borderRadius: "7px",
          //       }
          //     : {
          //         fontSize: "12px",
          //         fontWeight: "400",
          //         padding: "0px 3px",
          //         height: "30px",
          //         background: "#404040",
          //         borderColor: "#404040",
          //         borderRadius: "7px",
          //         marginLeft: "10px",
          //       }
          // }
        /> */}
        
      </div>
    </>
  );
};

export default ApplyFilter;
